export const isGroundClippingEnabled = (value) =>
  value === undefined || value === null ? true : Boolean(value);
